import React from 'react';
import clsx from 'clsx'

import { AppLinkProps } from './AppLinkProps'
import { APP_COLOR, APP_FONT_SIZE } from '../AtomsGlobalProps'

import { ReactComponent as ExternalLinkIcon } from '../../../icons/svg/external-link-icon.svg'
import './AppLinkStyles.scss'

/**
 * Atom pozwalający na tworzenie linków zgodnych z systemem designu.
 * 
 * @param {APP_COLOR} color - Kolor linku zgodny z systemem designu.
 * @param {APP_FONT_SIZE} size  - Rozmiar linku zgodny z systemem designu.
 * @param {Boolean} underline - Czy podkreślony
 * @param {Boolean} externalCard - Czy link ma otwierać się w nowej karcie (domyślnie true)
 */
const AppLink = (props: AppLinkProps) => {
   const { 
      href, className, color = APP_COLOR.PRIMARY, size = APP_FONT_SIZE.SMALL, 
      externalCard = false, children, align = 'left', ...restProps 
   } = props
   const externalProps = externalCard ? { target: '_blank', rel: 'noopener noreferrer' } : {}

   
   return (
      <a
         href={href}
         className={clsx(
            className, 'app-link', { 'app-link--external': externalCard }, 
            `app-link--${color.toLowerCase()}`, 
            `app-link--${size.toLowerCase()}`,
            `app-link--align-${align.toLocaleLowerCase()}`
         )}
         {...externalProps}
         {...restProps}
      >
         {externalCard && <ExternalLinkIcon width="1em" height="1em" aria-hidden={true} focusable={false} style={{ marginTop: 2 }} />}
         {children}
      </a>
   )
}

export default AppLink
